// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const InfoText = styled.div`
  color: var(--mb-color-text-secondary);
`;
